<template>

    <BaseContainer>

        <header class="mb-6">

            <h1 class="text-gray-800 font-bold text-xl leading-none mb-2" v-text="$t('labels.registrations')"></h1>

            <Breadcrumbs :current="Route.REGISTRATION_EDIT"/>

        </header>

        <BaseCard class="p-6">

            <RegistrationForm ref="form" @success="$router.push({ name: Route.REGISTRATION_INDEX })"/>

        </BaseCard>

    </BaseContainer>

</template>

<script setup>
    import Route from '@/constants/route'

    const form = ref()
    const route = useRoute()
    
    onMounted(() => nextTick(() => form.value.edit(route.params.id)))
</script>
